import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';

import { HandleErrorService } from '../services/handle-error.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  httpRequestCount = 0;
  constructor(
    private errorService: HandleErrorService,
    private spinner: NgxSpinnerService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.httpRequestCount++;
    this.spinner.show();
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        } else {
          errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
        }
        this.errorService.handleError(error);
        return throwError(error);
      }),
      finalize(() => {
        this.httpRequestCount--;
        const timer$ = timer(500)
          .pipe(take(1))
          .subscribe(() => {
            if (this.httpRequestCount <= 0) this.spinner.hide();
          });
      })
    );
  }
}
